<template>
    <nav class="navigation">
        <button v-if="currentIndex > 0" class="prev" @click="prev()"><span>Zurück</span></button>
        <button v-if="currentIndex < options.length - 1 && showNext && name.length" class="next" @click="next()"><span>Weiter</span></button>
    </nav>
</template>
<script>
export default {
    computed: {
        currentIndex: {
            get() {
                return this.$store.state.currentIndex
            },
            set(value) {
                this.$store.commit('setCurrentIndex', { currentIndex: value })
            }
        },
        options: {
            get() {
                return this.$store.state.options
            }
        },
        selectedOptions: {
            get() {
                return this.$store.state.selectedOptions
            }
        },
        showNext: {
            get() {
                return this.$store.state.showNext
            }
        },
        name: {
            get() {
                return this.$store.state.name
            }
        }
    },
    methods: {
        prev() {
            let newIndex = this.currentIndex - 1 >= 0 ? this.currentIndex - 1 : 0

            this.goTo(newIndex)
        },
        next() {
            let newIndex = this.currentIndex + 1 <= this.options.length ? this.currentIndex + 1 : this.options.length

            this.goTo(newIndex)
        },
        goTo(index) {
            index = parseInt(index)
            if (index >= 0 && index <= this.options.length) {
                console.log(index)
                for (let i = 0; i <= index; i++) {
                    if (this.selectedOptions[i] !== undefined && this.selectedOptions[i].length) {
                        this.$router.push({ path: '/step' + (index + 1) })
                    }
                }
            }
        }
    }
}
</script>